import { defineStore } from 'pinia'
import { useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useEndOfLineTestingDocumentsStore = defineStore('endOfLineTestingDocuments', {
  state: () => ({
    data: undefined,
  }),
  getters: {
    getEndOfLineTestingDocuments: (state) => state.data?.data,
  },
  actions: {
    async indexEndOfLineTestingDocuments(params = {}) {
      try {
        const response = await axios.get('end-of-line-testing-documents', {params});
        this.data = response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createEndOfLineTestingDocument(params = {}) {
      try {
        const response = await axios.get('end-of-line-testing-documents/create', {params});
        return useCreateForm(`end-of-line-testing-documents`, {...response.data, file: null});
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showEndOfLineTestingDocument(endOfLineTestingDocumentId, params = {}) {
      try {
        const response = await axios.get(`end-of-line-testing-documents/${ endOfLineTestingDocumentId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editEndOfLineTestingDocument(endOfLineTestingDocumentId, params = {}) {
      try {
        const response = await axios.get(`end-of-line-testing-documents/${ endOfLineTestingDocumentId }/edit`, {params});
        return useEditForm(`end-of-line-testing-documents/${ endOfLineTestingDocumentId }`, response.data);
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteEndOfLineTestingDocument(endOfLineTestingDocumentId, params = {}) {
      try {
        const response = await axios.delete(`end-of-line-testing-documents/${ endOfLineTestingDocumentId }`, {params});
        toasteventbus.emit('add', {
          summary: 'End Of Line Testing Document Deleted',
          detail: `End Of Line Testing Document has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
